import React from 'react';

const AccessIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="#000000"
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={15}
      height={15}
      viewBox="0 0 601.219 601.219"
      xmlSpace="preserve"
      className={`${
        props.className ? props.className : 'fill-blue hover:fill-white'
      }`}
    >
      <g>
        <g>
          <path
            d="M68.443,565.926c6.316,0,12.491-1.148,18.357-3.402c2.408-0.928,4.915-1.439,7.06-1.439c1.444,0,3.394,0.23,4.483,1.32
			l29.587,29.584c5.955,5.951,13.868,9.23,22.283,9.23s16.328-3.275,22.283-9.23l27.255-27.256
			c5.961-5.945,9.248-13.865,9.248-22.287c0-8.42-3.29-16.336-9.257-22.291l-29.575-29.574c-1.462-1.463-1.466-3.848-0.003-5.312
			l4.691-4.703c0.899-0.902,1.925-1.094,2.625-1.094s1.723,0.191,2.619,1.09l29.612,29.652c5.958,5.957,13.874,9.238,22.289,9.238
			s16.331-3.281,22.283-9.236l27.255-27.252c12.207-12.326,12.207-32.314,0.043-44.596l-29.63-29.631
			c-0.906-0.902-1.096-1.938-1.096-2.645c0-0.705,0.19-1.736,1.096-2.643l118.106-118.125c1.57-1.567,4.793-2.623,8.018-2.623
			c1.678,0,3.309,0.282,4.594,0.79c17.467,6.916,35.842,10.422,54.611,10.422c38.994,0,75.656-15.162,103.236-42.693
			c57.344-57.427,57.34-150.775,0.006-208.107C512.719,15.312,475.754,0,436.432,0c-39.32,0-76.285,15.309-104.088,43.112
			c-41.231,41.228-53.894,103.159-32.266,157.777c1.573,3.972,0.683,10.104-1.83,12.619L32.531,479.281
			c-9.565,9.555-14.835,22.311-14.835,35.912s5.272,26.355,14.841,35.916C42.087,560.66,54.841,565.926,68.443,565.926z
			 M390.866,147.162c0-12.207,4.725-23.651,13.299-32.228c8.613-8.611,20.07-13.357,32.268-13.357
			c12.195,0,23.654,4.743,32.268,13.357c8.578,8.577,13.299,20.021,13.299,32.228c0,12.206-4.725,23.651-13.299,32.228
			c-8.602,8.571-20.064,13.302-32.268,13.302s-23.666-4.728-32.279-13.314C395.588,170.815,390.866,159.371,390.866,147.162z"
          />
        </g>
      </g>
    </svg>
  );
};

export default AccessIcon;
